import { AppIdentifier, ApplicationConfigList } from '@aipb/env/model';
import { FrameAction, FrameApplication, RouteCategory, RouteItem } from '@aipb/frame/model';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { setTag } from '@sentry/angular';
import { FrameRepository } from './frame.repository';

@Injectable({
  providedIn: 'root'
})
export class FrameService {
  frameRepository = inject(FrameRepository);
  router = inject(Router);

  init(applications: ApplicationConfigList): void {
    this.setApps(applications);
  }

  setLoading(loading: boolean): void {
    this.frameRepository.setLoading(loading);
  }

  updateAppHistory(app: AppIdentifier, url: string) {
    this.frameRepository.updateAppHistory(app, url);
  }

  addDynamicRoute(routeItem: Omit<RouteItem, 'icon'>): void {
    this.frameRepository.addDynamicRoute(routeItem);
  }

  setRouteCategories(routeCategories: RouteCategory[] = []): void {
    this.frameRepository.setRouteCategories(routeCategories);
  }

  removeRoute(routeItem: RouteItem): void {
    this.frameRepository.removeDynamicRoute(routeItem);

    const prevIndex = this.frameRepository.getDynamicRouteIndex(routeItem) - 1;

    if (prevIndex === -1) return;

    const prevRoute = this.frameRepository.getDynamicRouteByIndex(prevIndex);

    if (!prevRoute) return;

    this.router.navigate([prevRoute.url]);
  }

  setup(id: AppIdentifier): void {
    setTag('app', id);

    this.frameRepository.setActiveApp(id);
    this.frameRepository.setActions([]);
    this.frameRepository.setStaticRoutes([]);
  }

  setActions(actions: FrameAction[]): void {
    this.frameRepository.setActions(actions);
  }

  setStaticRoutes(staticRoutes: RouteItem[]): void {
    this.frameRepository.setStaticRoutes(staticRoutes);
  }

  setDynamicRoutes(staticRoutes: RouteItem[]): void {
    this.frameRepository.setDynamicRoutes(staticRoutes);
  }

  setIsMobile(isMobile: boolean): void {
    this.frameRepository.setIsMobile(isMobile);
  }

  setSidebarExpanded(expanded = true): void {
    this.frameRepository.setSidebarExpanded(expanded);
    window.dispatchEvent(new Event('resize'));
  }

  toggleSidebarExpand(): void {
    this.frameRepository.toggleSidebarExpanded();
    window.dispatchEvent(new Event('resize'));
  }

  setForceFullHeight(forceFulLHeight: boolean): void {
    this.frameRepository.setForceFullHeight(forceFulLHeight);
  }

  setConfigId(app: AppIdentifier, configId: string) {
    this.frameRepository.setConfigId(app, configId);
  }

  private setApps(apps: ApplicationConfigList): void {
    const applications: FrameApplication[] = [];

    for (const key of Object.keys(apps)) {
      // @ts-expect-error foo
      for (const configId of Object.keys(apps[key])) {
        applications.push({
          id: <AppIdentifier>key,
          configId: configId,
          // @ts-expect-error foo
          category: apps[key][configId].category,
          // @ts-expect-error foo
          label: apps[key][configId].title,
          link: `/${key}/${configId}`,
          // @ts-expect-error foo
          hideInMenu: 'hideInMenu' in apps[key][configId] ? apps[key][configId].hideInMenu : false,
          // @ts-expect-error foo
          icon: apps[key][configId].icon,
          // @ts-expect-error foo
          logo: apps[key][configId].logo,
          // @ts-expect-error foo
          labelTooltip: apps[key][configId].tooltip
        });
      }
    }

    this.frameRepository.setApplications(applications);
  }
}
